import {merge} from '#core/utils/config-utils.js';

import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

export function outrightCardsFactory(PALETTE, COLOR_MODE) {
    return {
        OutrightEventCardClassic: merge(generateOutrightEventCardClassicDetails(PALETTE.CARD_EVENT_DETAILS_LIGHT), {
            mode: COLOR_MODE,
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            eventCardBase: {
                container: {
                    style: {
                        justifyContent: 'space-between',
                    },
                },
            },
            topContainer: {
                style: {
                    justifyContent: 'space-between',
                },
            },
            headerContainer: {
                style: {
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                    justifyContent: 'initial', // fixing wrong mojito style
                },
            },
            marketHeader: {
                style: {
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                },
            },
            eventCardDetailsDark: generateOutrightEventCardClassicDetails(PALETTE.CARD_EVENT_DETAILS_DARK),
        }),
    };
}

function generateOutrightEventCardClassicDetails(CARD_DETAILS) {
    return {
        eventCardBase: {
            title: {
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
        },
        marketNameLabel: {
            style: CARD_DETAILS.MARKET_NAME_TEXT,
        },
        showAllLabel: {
            container: {
                flexShrink: 0,
            },
            style: CARD_DETAILS.SHOW_ALL_LINK.SECONDARY_LINK_TEXT,
        },
        showAllIcon: {
            style: {
                fill: CARD_DETAILS.SHOW_ALL_LINK.SECONDARY_LINK_ICON_COLOR,
            },
        },
        sportIcon: {
            icon: {
                style: {
                    fill: CARD_DETAILS.SPORT_ICON_COLOR,
                    minWidth: 12,
                },
            },
        },
        selectionButton: generateOddsButton(CARD_DETAILS.ODDS_BUTTON),
    };
}
